import React, { Component, CSSProperties } from 'react';
import '../css/modal.css';

interface ModalProps {
    isOpen: boolean;
    onClose: () => void;
    title?: string;
    dialogStyles?: CSSProperties;
    children?: React.ReactNode;
}

class Modal extends Component<ModalProps> {
    render() {
        const { isOpen, onClose, title, dialogStyles, children } = this.props;
        if (!isOpen) return null;

        const defaultStyles: CSSProperties = {
            backgroundColor: 'var(--bg-modal)',
            color: 'var(--text-modal)',
            width: '70%',
            height: '80%',
            maxWidth: '600px',
            maxHeight: '500px',
            position: 'fixed',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            zIndex: 1001,
            padding: '20px',
            borderRadius: '8px',
            overflow: 'auto',
            boxSizing: 'border-box',
        };

        return (
            <>
                <div className="modal__overlay" onClick={onClose} />
                <div style={{ ...defaultStyles, ...dialogStyles }}>
                    {title && <h2 className="modal__title">{title}</h2>}
                    <div className="modal__content">
                        {children}
                    </div>
                </div>
            </>
        );
    }
}

export default Modal;
